import { MovieStreamMetaFragment } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { DrmConfig } from '@/scenarios/legacy-player/types/config';
import { DRM_SERVER_NAME } from '@/scenarios/legacy-player/constants/drm';

export const transformGqlDrmToPlayerDrm: (
    drmConfig: MovieStreamMetaFragment['drmConfig'] | undefined
) => DrmConfig | undefined = (drmConfig) => {
    if (!drmConfig) {
        return undefined;
    }

    return {
        servers: drmConfig.drmServers.reduce<Record<string, string>>((acc, server) => {
            if (server) {
                acc[server.name] = server?.url;
            }

            return acc;
        }, {}),
        headers: drmConfig.headers as Record<string, string>, // TODO OTT-65146
        requestParams: drmConfig.requestParams as DrmConfig['requestParams'], // TODO OTT-65146
        advanced: drmConfig.drmServers.reduce<NonNullable<DrmConfig['advanced']>>((acc, server) => {
            if (server?.name === DRM_SERVER_NAME.fairPlay) {
                const { name, processSPCPath, provisioningUrl, certificateUrl } = server;

                acc[name] = {
                    provisioningUrl: provisioningUrl || undefined,
                    serverCertificateUrl: certificateUrl || undefined,
                    processSPCPath: processSPCPath || undefined,
                };
            }

            return acc;
        }, {}),
    };
};
